import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { StyledFooter } from "@/styles";

import version from "../../../../package.json";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <StyledFooter>
            <Typography
                color="primary"
                variant="h6"
                sx={{
                    textAlign: "center",
                }}
            >
                {t("labels.copyrights")} &copy; {new Date().getFullYear()}
            </Typography>
            <Typography
                variant="caption"
                sx={{
                    display: "block",
                    mt: 2,
                    textAlign: "center",
                }}
            >
                {`${t("labels.version")} ${version?.version}`}
            </Typography>
        </StyledFooter>
    );
};

export default Footer;
